type MenuOptions = {
  label: string;
  id: string;
};

export const I18N_MENU_OPTIONS: MenuOptions[] = [
  {
    label: 'English',
    id: 'en-us',
  },
  {
    label: 'Français',
    id: 'fr-ca',
  },
  {
    label: 'Española',
    id: 'es-mx',
  },
];
